import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Pages/Blogs.css";

function Blogs() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch("/blogs.json")
      .then((res) => res.json())
      .then((data) => setBlogs(data.blogs || []))
      .catch(() => setBlogs([]));
  }, []);

  const displayBlogs = blogs.slice(0, 6);
  const featuredBlog = displayBlogs[0] || null;
  const gridBlogs = featuredBlog ? displayBlogs.slice(1) : displayBlogs;

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });

  const BlogOverlayCard = ({ blog }) => (
    <Link to={`/blog/${blog.slug}`} className="home-blog-overlay-card">
      <img src={blog.image} alt={blog.title} />
      <div className="home-blog-overlay-content">
        <span className="home-blog-overlay-date">{formatDate(blog.date)}</span>
        <h4>{blog.title}</h4>
        <p>{blog.desc}</p>
      </div>
    </Link>
  );

  return (
    <section id="home-blogs" className="our-blog-section ptb-100 gray-light-bg home-blogs-section">
      <div className="container blogs-surface">
        <div className="row justify-content-center mb-4">
          <div className="col-12">
            <div className="section-heading text-center">
              <h2 className="web">Insights & Updates</h2>
              <p>Explore insights and updates on healthcare innovation, industry trends, and the solutions shaping modern care delivery.</p>
            </div>
          </div>
        </div>

        {displayBlogs.length > 0 ? (
          <div className="home-blogs-split">
            {featuredBlog && (
              <div className="home-blogs-split-main">
                <BlogOverlayCard blog={featuredBlog} />
              </div>
            )}
            <div className="home-blogs-split-side">
              {gridBlogs.map((blog, i) => (
                <Link key={i} to={`/blog/${blog.slug}`} className="home-blog-split-item">
                  <img src={blog.image} alt={blog.title} />
                  <div className="home-blog-split-text">
                    <span>{formatDate(blog.date)}</span>
                    <h4>{blog.title}</h4>
                  </div>
                </Link>
              ))}
              {/* Empty slot CTA – minimal text + search icon */}
              {gridBlogs.length < 5 && (
                <Link to="/blogs" className="home-blog-split-item home-blog-split-item--cta home-blog-split-item--cta-minimal">
                  <div className="home-blog-split-text home-blog-split-text--full home-blog-split-cta-icon-heading">
                    <i className="fas fa-search" aria-hidden="true"></i>
                    <h4>Discover More Articles</h4>
                  </div>
                </Link>
              )}
            </div>
          </div>
        ) : (
          <p className="text-center">Loading blogs...</p>
        )}

      </div>
    </section>
  );
}

export default Blogs;
